import { InjectionToken } from '@angular/core';
import { IOption } from '../../filters';
import { CompoundFilterConfig } from '../../../compound-filter-selection/compound-filter-selection.model';

export interface FilterOptionConfig {
  getFilterOptionsMenu: (params?: { isReports: boolean; filter: IOption }) => FilterOptionMenuItem[];
}

export interface FilterOptionMenu {
  labelKey: string;
  value: string;
  cssClass: string | null;
}

export interface FilterOptionMenuItem {
  label: string;
  value: string;
  cssClass: string | null;
}

export interface DateRangeFilterOption {
  label: string;
  key: string;
}

export interface DateRangeFilterConfig {
  getOptionsForRecordSearch: () => DateRangeFilterOption[];
  getOptionsForReports: () => DateRangeFilterOption[];
}

export interface FilterConfig {
  compoundFilters?: Record<number, CompoundFilterConfig>;
  dateRange?: DateRangeFilterConfig;
}

export const DEFAULT_OPT: FilterOptionMenu = Object.freeze({
  labelKey: 'recordSearch.default',
  value: 'default',
  cssClass: 'default',
});

export const INCLUDE_EMPTY: FilterOptionMenu = Object.freeze({
  labelKey: 'recordSearch.includeEmpty',
  value: 'includeEmpty',
  cssClass: null,
});

export const EXCLUDE_EMPTY: FilterOptionMenu = Object.freeze({
  labelKey: 'recordSearch.excludeEmpty',
  value: 'excludeEmpty',
  cssClass: null,
});

export const EXCLUDE_SELECTION: FilterOptionMenu = Object.freeze({
  labelKey: 'recordSearch.excludeSelection',
  value: 'excludeSelection',
  cssClass: null,
});

export const createFilterOptionConfig = (
  translateFn: (key: string) => string,
  menuOptions: FilterOptionMenu[]
): FilterOptionConfig =>
  Object.freeze({
    getFilterOptionsMenu: () => menuOptions.map(({ labelKey, ...rest }) => ({ ...rest, label: translateFn(labelKey) })),
  });

export const DefaultFilterOptionConfigFactory = () =>
  createFilterOptionConfig(
    key => key,
    [{ ...DEFAULT_OPT }, { ...INCLUDE_EMPTY }, { ...EXCLUDE_EMPTY }, { ...EXCLUDE_SELECTION }]
  );

export const FILTER_OPTIONS_CONFIG_TOKEN = new InjectionToken<FilterOptionConfig>('FILTER_OPTIONS_CONFIG_TOKEN');

export const FILTER_OPTION_HIDDEN_IDS_TOKEN = new InjectionToken<readonly number[]>(
  'FILTER_OPTION_HIDE_SETTINGS_ICON_FOR_IDS_TOKEN'
);

export const FILTER_CONFIG_TOKEN = new InjectionToken<FilterConfig>('FILTER_CONFIG_TOKEN');
